import { render, staticRenderFns } from "./EachConference.vue?vue&type=template&id=67970262&scoped=true&"
import script from "./EachConference.vue?vue&type=script&lang=js&"
export * from "./EachConference.vue?vue&type=script&lang=js&"
import style0 from "./EachConference.vue?vue&type=style&index=0&id=67970262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67970262",
  null
  
)

export default component.exports